import { useCallback } from 'react'
import { useActivityTypesContext } from '../../../../context'
import { openActivityTypeFormActionCreator } from '../../../../state'

export function useHandlers() {
  const [, dispatch] = useActivityTypesContext()
  const handleCreateClick = useCallback(() => {
    dispatch(openActivityTypeFormActionCreator())
  }, [dispatch])

  return {
    handleCreateClick,
  }
}
